import { __t, applyTranslations } from 'utils/language';
import { DESCRIPTION, HASHTAG, TITLE } from 'modules/insights/sov/utils/queries/sov-queries';

import type { CheckboxesListItem } from 'types';
import type { SOVGeneralItem } from 'modules/insights/sov/types';

applyTranslations(require('modules/insights/sov/components/queries/sov-queries.i18n.json'));

const QUERIES_MSG_KEY = 'sov_queries';

export const CHECKBOX_LIST_ITEMS = [
  {
    label: __t(`${QUERIES_MSG_KEY}.labels.${HASHTAG}`),
    type: HASHTAG,
    isSelected: true
  },
  {
    label: __t(`${QUERIES_MSG_KEY}.labels.${TITLE}`),
    type: TITLE,
    isSelected: true
  },
  {
    label: __t(`${QUERIES_MSG_KEY}.labels.${DESCRIPTION}`),
    type: DESCRIPTION,
    isSelected: true
  }
];

export const prepareCheckboxesForEndpoint = (checkboxes: Array<CheckboxesListItem>, name: string): Array<SOVGeneralItem> => {
  const selectedCheckboxes = checkboxes.filter(item => item.isSelected);

  return selectedCheckboxes.map(item => ({
    keyword: name,
    type: item.type,
    selected: item.isSelected
  }));
};
